<template>
  <div>
    <div v-show="material_id == 0">
      <b-row class="col-12">
      <b-input-group small class="col-3 mt-3 mb-3">
        <b-button @click.prevent.stop="addmaterial" variant="primary" class="gdq_faded"><span class="icon-plus mr-2"></span>Add material</b-button>
      </b-input-group>

      <b-input-group small class="col-3 mt-3 mb-3">
        <b-form-input
          v-model="search"
          placeholder="Search heading"
          type="text"
          @input="materials_filter"
          autocomplete="off"
        >
        </b-form-input>
        <b-input-group-text slot="append">
          <b-btn
            variant="link"
            size="sm"
            @click="search = ''"
            class="p-0 i"
          >
          X
          </b-btn>
        </b-input-group-text>
      </b-input-group>
      <b-input-group small class="col-3 mt-3 mb-3">
        <label class="mt-2 mr-2">Show role:</label>
        <b-form-select
          v-model="usergroup_id"
          @input="materials_filter"
          :options="usergroups"
          autocomplete="off"
        >
        </b-form-select>
      </b-input-group>
      </b-row>
      <b-table 
        id="materials"
        hover 
        fixed
        :items="materials" 
        :fields="fields"
        :busy="loading"
        :sort-by="orderby"
        :sort-desc="orderdesc"
        @sort-changed="materials_sort"
        :no-local-sorting="true"
        ref="materials"
        @row-clicked="editmaterial"
      >
        <template v-slot:head(select)="data">
          <b-form-checkbox
          @click.native.stop
            @change="selectall(selected)"
            v-model="selected"
          >
            <span class="text-muted" v-if="selectcount>0">({{selectcount}})</span>
          </b-form-checkbox>
        </template>
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner variant="primary" class="align-middle"></b-spinner>
          </div>
        </template>
        <template v-slot:cell(select)="data">
        <div class="py-1">
            <b-form-checkbox
              :id="'selected'+data.index"
              v-model="data.item.selected"
              @change="countselected"
            >
            </b-form-checkbox>
          </div>
        </template>
        <template v-slot:cell(material_heading)="data">
          <div class="py-1">
            {{ data.item.material_heading }}
          </div>
        </template>
        <template v-slot:cell(empty)="data">
          <span 
            @click.prevent.stop="deletematerial(data.item.id)"
          >
            <fa-icon name="trash-alt" />
          </span>
        </template>
      </b-table>
      <b-row class="col-12 justify-content-center">
        <b-pagination
          v-if="rows > perPage"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="materials"
          @input="materials_get"
        >
        </b-pagination>
      </b-row>
    </div>
    <div v-show="material_id != 0">
      <Material />
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import Material from './Material';

const fields = [
  { key: 'select', label: '', sortable: false, thClass: 'col gdq-w-10', tdClass: 'col gdq-w-10' },
  { key: 'material_heading', label: 'Heading', sortable: true, thClass: 'col', tdClass: 'col' },
  { key: 'material_filename', label: 'File', sortable: true, thClass: 'col', tdClass: 'col' },
  { key: 'usergroup', label: 'Role', sortable: false, thClass: 'col', tdClass: 'col' },
  { key: 'empty', label: '', sortable: false, thClass: 'col gdq-w10', tdClass: 'col gdq-w-10' },
];
export default {
  components: {
    Material,
  },
  name: 'Materials',
  mounted() {
    this.usergroups_get();
    this.materials_get()
  },
  data: function() {
    return {
      search: '',
      searching: false,
      searchcalc: false,
      fields: fields,
      usergroup_id: 0,
      usergroups: [],
      materials: [],
      allowmultiselect: false,
      muteclass: 'text-muted',
      currentPage: 1,
      perPage: 10,
      rows: 0,
      loading: null,
      orderby: 'material_heading',
      orderdesc: false,
      selected: 0,
      bulkaction: 0,
      selectcount: 0,
    }
  },
  computed: {
    material_id: {
      get() {
        return this.$store.state.currentmaterial_id;
      }
    },
    materialchanged: {
      get() {
        return this.$store.state.materialchanged;
      }
    },
  },
  watch: {
    search: function() {
      this.searching = true
      this.materials_filter()
    },
    materialchanged: function() {
      if (this.$store.state.materialchanged != 0) {
        this.material_get(this.$store.state.materialchanged);
        this.$store.dispatch('materialchanged_set',{ material_id: 0 });
      }
    },
    material_id: function() {
      this.materials_get();
    },
  },
  methods: {
    usergroups_get() {
      var usergroups = [];
      usergroups.push( { value: 0, text: 'All roles' } );
      for (var i = 0;i < this.$store.state.usergroups.length; i++) {
        var usergroup = {
          value: this.$store.state.usergroups[i].id,
          text: this.$store.state.usergroups[i].name,
        }
        usergroups.push(usergroup);
      }
      this.usergroups = usergroups;
    },
    deletematerial(id) {
      this.$store.dispatch('material_delete', { material_id: id })
      .then(() => {
        this.materials_get();
      });
    },
    addmaterial() {
      this.$store.dispatch('material_setcurrent',{ material_id: -1 })
      .then(() => {
        this.materials_get();
      });
    },
    editmaterial(item) {
      this.$store.dispatch('material_setcurrent',{ material_id: item.id })
      .then(() => {
        this.materials_get();
      });
    },
    material_get(material_id) {
      var material_heading = '';
      this.$store.dispatch('material_fetch', { material_id: material_id })
      .then((resp) => {
        material_heading = resp.data.material_heading;
        for (var i=0; i<this.materials.length; i++) {
          if (this.materials[i].id == material_id) {
            this.materials[i].material_heading = material_heading;
          }
        }
      });
    },
    selectall(selected) {
      var setselectto = !selected;
      for (var i=0;i<this.materials.length; i++) {
        this.materials[i].selected = setselectto;
      }
      this.countselected();
    },
    countselected() {
      this.$nextTick(() => {
        var selectcount = 0;
        for (var i=0;i<this.materials.length; i++) {
          if (this.materials[i].selected) {
            selectcount++;
          }
        }
        this.selectcount = selectcount;
      })
    },
    materials_filter: _.debounce(function() {
      this.searchcalc = true
      setTimeout(function() {
        this.materials_get();
        this.searchcalc = false;
        this.searching = false;
      }.bind(this),500)
    },300),
    materials_sort(context) {
      this.orderby = context.sortBy;
      this.orderdesc = context.sortDesc;
      this.materials_get();
    },
    materials_get() {
      this.loading = true;
      var filter = '';
      if (this.search != '') {
        filter = {
          material_heading: {
            operator: 'LIKE',
            value: '%'+this.search+'%',
          },
        }
      } else {
        filter = {
          id: {
            operator: ' > ',
            value: 0,
          }
        }
      }
      if (this.usergroup_id != 0) {
        filter.material_usergroup_id = {
          operator: ' = ',
          value: this.usergroup_id,
        }
      }
      this.$store.dispatch('materials_fetch', {
        start: (this.currentPage-1)*this.perPage,
        limit: this.perPage,
        orderby: this.orderby,
        order: (this.orderdesc==false)?'ASC':'DESC',
        filter: filter,
        usergroup_id: this.filterusergroup,
      })
      .then((resp) => {
         this.materials = [];
         var usergroups = this.usergroups;
         for (var i=0;i<resp.data.result.length;i++) {
           var usergroup_id = resp.data.result[i].material_usergroup_id;
           var usergroup_name = 'Consultant';
           for (var j=0;j<usergroups.length;j++) {
             if (usergroups[j].value == usergroup_id) {
               usergroup_name = usergroups[j].text;
             }
           }
           var result = {
             id: resp.data.result[i].id,
             selected: false,
             material_heading: resp.data.result[i].material_heading,
             material_filename: resp.data.result[i].material_filename,
             usergroup: usergroup_name,
           }
           this.materials.push(result);
         }
         this.rows = resp.data.total;
         this.loading = false;
      });
    },
  },
}
</script>
<style>
</style>
